import { SVGProps } from 'react'
export const PlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={13}
    fill="none"
    {...props}
  >
    <rect width={2} height={12} x={4.898} y={0.57} fill="currentColor" rx={1} />
    <rect
      width={2}
      height={12}
      y={7.67}
      fill="currentColor"
      rx={1}
      transform="rotate(-90 0 7.67)"
    />
  </svg>
)
